<router-outlet></router-outlet>
<app-tab-conflict-overlay></app-tab-conflict-overlay>

<!-- <ngx-spinner
  bdColor="rgba(23,75,130,0.8)"
  size="large"
  color="#fff"
  type="ball-clip-rotate-multiple"
  [fullScreen]="true"
><p style="color: white">Please wait...</p></ngx-spinner
> -->
